// Application data constants
// This file contains static data used throughout the application

// List of all available stat categories (matches backend API)
export const statCategories = [
  "3rd Down Conversion Pct",
  "3rd Down Conversion Pct Defense",
  "4th Down Conversion Pct",
  "4th Down Conversion Pct Defense",
  "Blocked Kicks",
  "Blocked Kicks Allowed",
  "Blocked Punts",
  "Blocked Punts Allowed",
  "Completion Percentage",
  "Defensive TDs",
  "Fewest Penalties",
  "Fewest Penalties Per Game",
  "Fewest Penalty Yards",
  "Fewest Penalty Yards Per Game",
  "First Downs Defense",
  "First Downs Offense",
  "Fumbles Lost",
  "Fumbles Recovered",
  "Kickoff Return Defense",
  "Kickoff Returns",
  "Net Punting",
  "Passes Had Intercepted",
  "Passes Intercepted",
  "Passing Offense",
  "Passing Yards Allowed",
  "Passing Yards per Completion",
  "Punt Return Defense",
  "Punt Returns",
  "Red Zone Defense",
  "Red Zone Offense",
  "Rushing Defense",
  "Rushing Offense",
  "Sacks Allowed",
  "Scoring Defense",
  "Scoring Offense",
  "Tackles for Loss Allowed",
  "Team Passing Efficiency",
  "Team Passing Efficiency Defense",
  "Team Sacks",
  "Team Tackles for Loss",
  "Time of Possession",
  "Total Defense",
  "Total Offense",
  "Turnover Margin",
  "Turnovers Gained",
  "Turnovers Lost",
  "Winning Percentage",
];

// List of all NCAA FBS team names
export const teamNames = [
  "Georgia Tech",
  "Virginia",
  "SMU",
  "Pittsburgh",
  "Miami (FL)",
  "Duke",
  "Wake Forest",
  "Louisville",
  "California",
  "Clemson",
  "NC State",
  "North Carolina",
  "Stanford",
  "Virginia Tech",
  "Florida St.",
  "Syracuse",
  "Boston College",
  "Navy",
  "North Texas",
  "Tulane",
  "East Carolina",
  "South Fla.",
  "Memphis",
  "UTSA",
  "Temple",
  "Army West Point",
  "Fla. Atlantic",
  "Rice",
  "UAB",
  "Tulsa",
  "Charlotte",
  "Texas Tech",
  "BYU",
  "Utah",
  "Houston",
  "Cincinnati",
  "Arizona St.",
  "Arizona",
  "Kansas St.",
  "Iowa St.",
  "TCU",
  "Baylor",
  "Kansas",
  "West Virginia",
  "UCF",
  "Colorado",
  "Oklahoma St.",
  "Indiana",
  "Ohio St.",
  "Oregon",
  "Southern California",
  "Michigan",
  "Washington",
  "Nebraska",
  "Illinois",
  "Iowa",
  "Minnesota",
  "Northwestern",
  "UCLA",
  "Rutgers",
  "Penn St.",
  "Maryland",
  "Wisconsin",
  "Michigan St.",
  "Purdue",
  "Jacksonville St.",
  "Western Ky.",
  "Kennesaw St.",
  "Missouri St.",
  "FIU",
  "Louisiana Tech",
  "Liberty",
  "Delaware",
  "New Mexico St.",
  "UTEP",
  "Sam Houston",
  "Middle Tenn.",
  "Notre Dame",
  "UConn",
  "Western Mich.",
  "Ohio",
  "Central Mich.",
  "Miami (OH)",
  "Toledo",
  "Buffalo",
  "Akron",
  "Ball St.",
  "Eastern Mich.",
  "Kent St.",
  "NIU",
  "Bowling Green",
  "Massachusetts",
  "San Diego St.",
  "UNLV",
  "New Mexico",
  "Fresno St.",
  "Boise St.",
  "Hawaii",
  "Utah St.",
  "Wyoming",
  "Air Force",
  "San Jose St.",
  "Nevada",
  "Colorado St.",
  "Washington St.",
  "Oregon St.",
  "Texas A&M",
  "Georgia",
  "Ole Miss",
  "Alabama",
  "Oklahoma",
  "Vanderbilt",
  "Texas",
  "Tennessee",
  "Missouri",
  "LSU",
  "Kentucky",
  "Florida",
  "Mississippi St.",
  "Auburn",
  "South Carolina",
  "Arkansas",
  "James Madison",
  "Coastal Carolina",
  "Old Dominion",
  "Marshall",
  "Ga. Southern",
  "App State",
  "Georgia St.",
  "Southern Miss.",
  "Troy",
  "Louisiana",
  "Arkansas St.",
  "South Alabama",
  "Texas St.",
  "ULM",
];

